/**
 * Topo "redondo" do eixo Y para `n` divisões: o menor múltiplo de 1, 2, 2,5 ou
 * 5 × 10^k cujo n-ésimo passo cobre o máximo. Devolve os valores dos ticks,
 * de 0 até o topo (n + 1 valores).
 */
export function ticksEixo(maximo: number, n = 4): number[] {
  if (!(maximo > 0)) return Array.from({ length: n + 1 }, (_, i) => i);
  const bruto = maximo / n;
  const potencia = 10 ** Math.floor(Math.log10(bruto));
  const passo = [1, 2, 2.5, 5, 10].map((f) => f * potencia).find((p) => p * n >= maximo) ?? 10 * potencia;
  return Array.from({ length: n + 1 }, (_, i) => i * passo);
}
